export const GET_IP_LOCATION_URL = '/api/getIpLocation';
export const GET_REVIEWS_URL = '/api/product/reviews';
